import * as React from 'react';
import { ArticleChangeImportance, articleChangeImportanceValues } from '../../../amorg-common';
import { ImportanceAvatar } from '../../../designSystem/avatar/ImportanceAvatar';
import { ArticleImportanceVariant } from '../../../txt';
import { RadioButtonButtonList } from '../../../designSystem/inputs/RadioButtonButton';

type ArticleImportanceSelectorProps = {
    mode:Exclude<ArticleImportanceVariant, 'change'>,
    selectedImportance: ArticleChangeImportance | null,
    onChangeImportance: (importance: ArticleChangeImportance | null) => void,
}
export function ArticleImportanceSelector(props:ArticleImportanceSelectorProps):JSX.Element
{
    return (
        <RadioButtonButtonList
            groupName="importanceSelector"
            options={[
                {
                    text:'',
                    value:'',
                    leadingContent:<ImportanceAvatar importance={undefined} mode={props.mode} size="16px" />
                },
                { 
                    text: '' /*props.mode==='internalArticle' 
                        ? txt.InternalArticleEvaluation_low_text 
                        : txt.ArticleEvaluation_low_text*/, 
                    value: 'low', 
                    leadingContent:<ImportanceAvatar importance="low" mode={props.mode} size="16px" />,
                },
                { 
                    text: '' /*props.mode==='internalArticle'
                        ? txt.InternalArticleEvaluation_medium_text 
                        : txt.ArticleEvaluation_medium_text*/, 
                    value: 'medium',
                    leadingContent:<ImportanceAvatar importance="medium" mode={props.mode} size="16px" />
                },
                {
                    text: '' /*props.mode==='internalArticle'
                        ? txt.InternalArticleEvaluation_high_text 
                        : txt.ArticleEvaluation_high_text*/,
                    value: 'high',
                    leadingContent:<ImportanceAvatar importance="high" mode={props.mode} size="16px" /> 
                }
            ]}
            selectedValue={props.selectedImportance || ''}
            onChange={(value) =>
                props.onChangeImportance(
                    articleChangeImportanceValues.includes(value as ArticleChangeImportance)
                        ? value as ArticleChangeImportance
                        : null
                )
            }
        />
    );
}